export default __webpack_public_path__ + "static/media/DealPicturePlaceholder.e2d2a15d.jpg";